import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useTicketManagementMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemTicket */
  const menuItemTicket = {
    id: "ticket",
    title: t("Modules.TicketManagement.ticket"),
    url: baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT),
  };
  tempMenuGroup.push(menuItemTicket);

  return tempMenuGroup;
};
